module.exports = __webpack_public_path__ + "static/img/lead-inter-asset-leadBg.d001890.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lead-inter-asset-leadBg.png
// module id = beY4
// module chunks = 1